<div class="flex-basis no-padding-right">
  <div class="jump-to-pages">
    <input
      id="current-page"
      type="text"
      name="currPage"
      [ngModel]="currentPage"
      (ngModelChange)="toPage = $event"
      [min]="1"
      [max]="totalPages"
      [ngClass]="totalPages < 100 ? 'two-length-input' : 'three-length-input'"
      [attr.aria-label]="'pdfViewer.currentPage' | translate" />
    <span class="line-seperator">/</span>
    <span id="total-pages" class="total-pages">{{ totalPages }}</span>
  </div>
</div>
<div class="flex-basis seperator no-padding-left">
  <div class="jump-to-pages-btns">
    <button
      class="btn btn-link jump-page-bottom"
      [ngClass]="{ disable: currentPage == 1 }"
      id="prev-page"
      [disabled]="currentPage == 1"
      (click)="toPage = currentPage - 1"
      attr.aria-label="{{ 'pdfViewer.previousPage' | translate }}"
      attr.value="{{ 'pdfViewer.previousPage' | translate }}"
      accessibleTooltip
      [tooltip]="'pdfViewer.previousPage' | translate"
      triggers="manual"
      placement="bottom">
      <i class="fa fa-angle-up" attr.aria-hidden="true"></i>
    </button>
    <button
      [ngClass]="{ disable: currentPage == totalPages }"
      class="btn btn-link jump-page-top"
      id="next-page"
      [disabled]="currentPage == totalPages"
      (click)="toPage = currentPage + 1"
      attr.aria-label="{{ 'pdfViewer.nextPage' | translate }}"
      attr.value="{{ 'pdfViewer.nextPage' | translate }}"
      accessibleTooltip
      [tooltip]="'pdfViewer.nextPage' | translate"
      triggers="manual"
      placement="bottom">
      <i class="fa fa-angle-down" attr.aria-hidden="true"></i>
    </button>
  </div>
</div>
